module.exports = __webpack_public_path__ + "media/cards/19-63978ab2.png";